<template>
    <Card>
      <LocalDataTable :init-document="is_mounted" :functions="functions" :order-column="1" order-type="asc"  :columns="columns" ajax-link="admin/Product/List"></LocalDataTable>
    </Card>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import Card from "@/components/forms/Card";
import LocalDataTable from "@/components/LocalDataTable";
import {mapActions} from "vuex";
import Swal from "sweetalert2";
import {AppApi} from "@/api/AppApi";
import {showSystemNoti} from "@/shared/helper";
let mounted = false;
export default {
  name: "ProductList",
  components: {LocalDataTable, Card, MasterLayout},
  data(){
    return{
      is_mounted : mounted,
      functions:[
        {name: 'delFunc',method : this.delFunc}
      ],
      columns : [{title :'تصویر',sortable : false},{title :'عنوان'},{title :'عنوان انگلیسی'},{title :'<i class="far fa-cogs"></i>',sortable : false}],
    }
  },
  async mounted()
  {
    this.setPageTitle('محصولات');
    this.setShowHead(true);
    this.is_mounted = mounted;
    mounted = true;
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    async delFunc(id,title,element)
    {
      Swal.fire({
        title: 'آیا مطمئن هستید؟',
        text: "تمام اطلاعات مربوط به محصول "+title+" حذف می شود.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'تایید حذف!',
        cancelButtonText: 'کنسل',
      }).then(async (result) => {
        if (result.value) {
          const result = await AppApi.deleteProduct(id);
          if (result.ok)
          {
            if (element)
              $(element).closest('tr').remove();
            showSystemNoti('success', result.message);
          }
          else
            showSystemNoti('danger',result.error);
        }
      })
    }
  }
}
</script>

<style scoped>

</style>